import React, { useRef, useEffect, useState } from "react";
import { Stack, Text } from "@bookingcom/bui-react";
export function FlightTimelinePointUI(props) {
    const elmentRef = useRef();
    const [isVertical, setVariant] = useState(false);
    const { airport, dateTime, content, flightInfo, ...rest } = props;
    useEffect(() => {
        const element = elmentRef.current;
        if (!element)
            return;
        const observer = new ResizeObserver((entries) => {
            const { width } = entries[0].contentRect;
            const newDirection = width < 501;
            if (newDirection === isVertical)
                return;
            setVariant(newDirection);
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [isVertical, elmentRef]);
    if (!airport && !dateTime && !flightInfo && !content)
        return null;
    return (React.createElement(Stack, { ...rest, grow: true, gap: isVertical ? 4 : 8, direction: isVertical ? "column" : "row", attributes: { ref: elmentRef } },
        React.createElement(Stack.Item, { grow: true },
            dateTime ? React.createElement(Text, { variant: "small_1" }, dateTime) : undefined,
            airport ? React.createElement(Text, { variant: "strong_2" }, airport) : undefined,
            !isVertical && content ? (React.createElement(Stack, { grow: true, mixin: { marginBlockStart: 6 } },
                React.createElement(Stack.Item, null, content))) : undefined),
        flightInfo || (isVertical && content) ? (React.createElement(Stack.Item, { attributes: { style: { width: 250 } } },
            React.createElement(Stack, { gap: 2 },
                flightInfo ? React.createElement(Stack.Item, { grow: true }, flightInfo) : undefined,
                isVertical && content ? React.createElement(Stack.Item, { grow: true }, content) : undefined))) : undefined));
}
